import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IAPIData } from '@shared/interfaces/api.interface';
import { IIntegrationsERecruit } from '@shared/interfaces/integrations/integrations.erecruit.interface';
import { IntegrationsERecruit } from '@shared/models/integrations/integrations.erecruit.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsErecruitService {
  private readonly ENDPOINT: string = String(
    `${environment.SERVER_ENDPOINT}/api/services/erecruit`
  );

  constructor(private readonly _http: HttpClient) {}

  public authorize(
    params: IIntegrationsERecruit
  ): Observable<IIntegrationsERecruit> {
    const body = new IntegrationsERecruit(params).apiData;
    return this._http
      .post<any>(`${this.ENDPOINT}/auth`, body)
      .pipe(map((res: IAPIData) => IntegrationsERecruit.fromAPI(res)));
  }

  public delete(): Observable<IIntegrationsERecruit> {
    return this._http
      .delete(this.ENDPOINT)
      .pipe(map((res: IAPIData) => IntegrationsERecruit.fromAPI(res)));
  }

  public get(type: string, id: string): Observable<any> {
    return this._http.get(`${this.ENDPOINT}/entity`, {
      params: {
        entity_type: type,
        entity_id: id
      }
    });
  }
}
